import CardCategoryArticle from 'components/Frontend/Card/CardCategoryArticle'
import React from 'react'

function Tutorial() {
    return (
        // <div className="details-header">
        //     <div className="container">
        //         <div className="row mt-4">
        //             <h3 className="text-center mb-2">Pilih Kategori</h3>
        //             <CardCategoryArticle />
        //         </div>
        //     </div>
        // </div>
        <section id="services" className="services">
            <div className="container">
                <div className="section-title">
                    <h2>Kategori</h2>
                    <p>Temui Kelas Berdasarkan Kategori Yang Kami Sediakan</p>
                </div>

                <div className="row">
                    <CardCategoryArticle />
                </div>
            </div>
        </section>
    )
}

export default Tutorial
